import React from 'react';
import Grid, { GridItem } from 'components/Grid';
export function SearchWidgetLayout(_ref) {
  var widgets = _ref.widgets,
    children = _ref.children;
  if (!widgets) {
    // eslint-disable-next-line react/jsx-no-useless-fragment
    return /*#__PURE__*/React.createElement(React.Fragment, null, children);
  }
  return /*#__PURE__*/React.createElement(Grid, {
    reverse: true,
    hasBottomSpacing: true
  }, /*#__PURE__*/React.createElement(GridItem, {
    mSize: "1/4"
  }, widgets), /*#__PURE__*/React.createElement(GridItem, {
    mSize: "3/4"
  }, children));
}